import { createContext } from 'react';

export const ChatUnreadCountContext = createContext(0);
export const SetChatUnreadCountContext = createContext(() => {});
